import { Tooltip } from "@mui/material";
import Duration from "../../components/global/fields/DurationDatePicker.jsx";
import {
  csmStatusCPSOptions,
  afiliacionStatusCPSOptions,
  offerStatusCPSOptions,
  pixelStatus,
} from "../../json/StatusOptions";
import ColumnStatus from "../../components/global/fields/ColumnStatus.jsx";
import EditableText from "../../components/global/fields/EditableText.jsx";
import EditableSelectMultiple from "../../components/global/fields/EditableSelectMultiple.jsx";
import EditableSelect from "../../components/global/fields/EditableSelect.jsx";
import {
  otherOptions,
  publisherOptions,
  programManager,
  encargadaCsm,
} from "../../json/CampaignCreator";
import ThreadListModal from "../../pages/Threads/components/ThreadListModal.jsx";
import { countries } from "../../json/Countries";

export const getMasterCpsColumns = (
  state, 
  handlers, 
  utils, 
  config
) => {
  const {
    handleEditResponseChange
  } = handlers;

  const {
    mapFilterOptionsCode
  } = utils;

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 70,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "offerID",
      headerName: "Offer ID",
      width: 70,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "threads",
      headerName: "Thread",
      width: 70,
      headerAlign: "center",
      align: "center",

      renderCell: (params) => {
        return <ThreadListModal {...params} />;
      },
    },
    {
      field: "offerTitle",
      headerName: "Offer Title",
      width: 160,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "offerStatus",
      headerName: "OFFER Status",
      width: 160,
      cellClassName: "no-padding",
      headerAlign: "center",
      renderCell: (params) => (
        <ColumnStatus
          {...params}
          selectionRow={state.selectionRow}
          field={"offerStatus"}
          columnPosition={270}
          handleEditResponseChange={handleEditResponseChange}
          statusOption={offerStatusCPSOptions}
        />
      ),
    },
    {
      field: "duration",
      headerName: "Duration",
      width: 160,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Duration {...params} selectionRow={state.selectionRow} />
      ),
    },
    {
      field: "publisher",
      headerName: "Publisher",
      width: 170,
      headerAlign: "center",
      align: "center",

      renderCell: (params) => (
        <EditableSelectMultiple
          {...params}
          field={"publisher"}
          handleEditResponseChange={handleEditResponseChange}
          options={publisherOptions.map((opt) => opt.title)}
          getOptionLabelFunc={(opt) => opt}
          initialValue={params.row.publisher}
          label="Publisher"
        />
      ),
    },
    {
      field: "other",
      headerName: "Other",
      width: 170,
      headerAlign: "center",
      align: "center",

      renderCell: (params) => (
        <EditableSelectMultiple
          {...params}
          field={"other"}
          handleEditResponseChange={handleEditResponseChange}
          options={otherOptions.map((opt) => opt.title)}
          getOptionLabelFunc={(opt) => opt}
          initialValue={params.row.other}
          label="Other"
        />
      ),
    },
    {
      field: "csmStatus",
      headerName: "CSM Status",
      width: 160,
      cellClassName: "no-padding",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <ColumnStatus
          {...params}
          selectionRow={state.selectionRow}
          field={"csmStatus"}
          columnPosition={270}
          handleEditResponseChange={handleEditResponseChange}
          statusOption={csmStatusCPSOptions}
        />
      ),
    },
    {
      field: "affiliacionStatus",
      headerName: "Affiliacion Status",
      width: 160,
      cellClassName: "no-padding",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <ColumnStatus
          {...params}
          selectionRow={state.selectionRow}
          field={"affiliacionStatus"}
          columnPosition={270}
          handleEditResponseChange={handleEditResponseChange}
          statusOption={afiliacionStatusCPSOptions}
        />
      ),
    },
    {
      field: "pixelStatus",
      headerName: "Verificación de Pixel",
      width: 160,
      cellClassName: "no-padding",
      headerAlign: "center",
      renderCell: (params) => (
        <ColumnStatus
          {...params}
          selectionRow={state.selectionRow}
          field={"pixelStatus"}
          columnPosition={122}
          optionsAmount={"low"}
          handleEditResponseChange={handleEditResponseChange}
          statusOption={pixelStatus}
        />
      ),
    },
    {
      field: "advertiserName",
      headerName: "Advertiser Name",
      width: 160,
      headerAlign: "center",
      cellClassName: "cell-content",
      align: "center",

      renderCell: (params) => (
        <div className="container-cell-data">
          <Tooltip title={params.value}>
            <p className="cell-data">{params.value}</p>
          </Tooltip>
        </div>
      ),
    },
    {
      field: "typeOfClient",
      headerName: "Tipo de cliente",
      width: 120,
      headerAlign: "center",
      cellClassName: "cell-content",
      align: "center",

      renderCell: (params) => (
        <div>
          <p className="cell-data">{params.value}</p>
        </div>
      ),
    },
    {
      field: "encargadaCsm",
      headerName: "Encargada CSM",
      width: 160,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <EditableSelect
          {...params}
          field={"encargadaCsm"}
          handleEditResponseChange={handleEditResponseChange}
          options={encargadaCsm.map((encargada) => encargada.name)}
          spanText={params.row.encargadaCsm}
          initialValue={params.row.encargadaCsm}
          label="Encargada CSM"
        />
      ),
    },
    {
      field: "programManager",
      headerName: "Program Manager",
      width: 160,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <EditableSelect
          {...params}
          field={"programManager"}
          handleEditResponseChange={handleEditResponseChange}
          options={programManager.map((manager) => manager.name)}
          spanText={params.row.programManager}
          initialValue={params.row.programManager}
          label="Program Manager"
        />
      ),
    },
    {
      field: "country",
      headerName: "Country",
      width: 160,
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: mapFilterOptionsCode(countries),
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            textTransform: "uppercase",
          }}
        >
          {countries.map((el) => {
            if (params?.value === el.label || params?.value === el.code) {
              return (
                <>
                  <img
                    src={`https://flagcdn.com/w20/${el.code.toLowerCase()}.png`}
                    style={{ marginRight: "8px" }}
                    alt="img"
                  />
                </>
              );
            } else return null;
          })}
          {countries.map((el) => {
            if (
              params?.value?.toLowerCase() === el.label.toLowerCase() ||
              params?.value?.toLowerCase() === el.code.toLowerCase()
            ) {
              return <p>{el.code}</p>;
            } else return null;
          })}
        </div>
      ),
    },
    {
      field: "vertical",
      headerName: "Vertical",
      width: 160,
      headerAlign: "center",
      align: "center",

      renderCell: (params) => (
        <div className="container-cell-data">
          <Tooltip title={params.value}>
            <p className="cell-data">{params.value}</p>
          </Tooltip>
        </div>
      ),
    },
    {
      field: "trafficSources",
      headerName: "Traffic Sources Allowed",
      width: 220,
      headerAlign: "center",
      align: "center",

      renderCell: (params) => (
        <div className="container-cell-data">
          <Tooltip title={params.value}>
            <p className="cell-data">{params.value}</p>
          </Tooltip>
        </div>
      ),
    },
    {
      field: "targeting",
      headerName: "Targeting",
      width: 160,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <EditableText
          {...params}
          field={"targeting"}
          handleEditResponseChange={handleEditResponseChange}
          initialValue={params?.row?.targeting?.replace(/(<([^>]+)>)/gi, "")}
        />
      ),
    },
    {
      field: "conversionType",
      headerName: "Conversion Type",
      width: 160,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <EditableSelect
          {...params}
          field={"conversionType"}
          handleEditResponseChange={handleEditResponseChange}
          options={["CPL", "CPI", "CPM", "CPA"]}
          spanText={params.row.conversionType}
          initialValue={params.row.conversionType}
          label="Conversion Type"
        />
      ),
    },
    {
      field: "revenueUSD",
      headerName: "Revenue USD",
      width: 120,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "payoutUSD",
      headerName: "Payout USD",
      width: 100,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "createdAt",
      headerName: "Created At",
      width: 160,
      headerAlign: "center",
      align: "center",
    },
  ];

  return columns;
};